import notificationList from './notification-list.vue';
import notification from './notification.vue';

const components = Vue => {
    Vue.component('v-notification-list', notificationList);
    Vue.component('v-notification-item', notification)
}

export default components;